(() => {
  const showShopMenu = (navigation, restoreFocus = false) => {
    const appointment = navigation.querySelector('[data-mr-appointment-panel]');
    const menu = navigation.querySelector('[data-mr-shop-menu]');
    const panel = navigation.querySelector('[data-mr-shop-panel]');
    if (appointment) appointment.hidden = true;
    if (menu) menu.hidden = false;
    panel?.removeAttribute('data-mr-appointment-open');
    navigation.querySelectorAll('[data-mr-appointment-trigger]').forEach((link) => link.setAttribute('aria-expanded', 'false'));
    if (restoreFocus) navigation.querySelector('[data-mr-appointment-trigger]')?.focus({ preventScroll: true });
  };
  const animatePanel = (panel, previousHeight) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const height = panel.getBoundingClientRect().height;
    if (Math.abs(height - previousHeight) < 1) return;
    panel.getAnimations().forEach((animation) => animation.cancel());
    panel.animate([{ height: `${previousHeight}px` }, { height: `${height}px` }], { duration: 180, easing: 'ease-out' });
  };
  const closePanels = (navigation, restoreFocus = false) => {
    showShopMenu(navigation);
    navigation.querySelectorAll('[data-mr-panel]').forEach((button) => {
      if (restoreFocus && button.getAttribute('aria-expanded') === 'true') button.focus();
      button.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(button.dataset.mrPanel);
      if (panel) panel.hidden = true;
    });
  };
  const openAppointment = (navigation) => {
    const appointment = navigation.querySelector('[data-mr-appointment-panel]');
    const panel = navigation.querySelector('[data-mr-shop-panel]');
    const menu = navigation.querySelector('[data-mr-shop-menu]');
    if (!appointment || !panel || !menu) return false;
    const previousHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    closePanels(navigation);
    panel.hidden = false;
    panel.setAttribute('data-mr-appointment-open', '');
    menu.hidden = true;
    appointment.hidden = false;
    navigation.querySelector(`[data-mr-panel="${panel.id}"]`)?.setAttribute('aria-expanded', 'true');
    navigation.querySelectorAll('[data-mr-appointment-trigger]').forEach((link) => link.setAttribute('aria-expanded', 'true'));
    appointment.querySelector('h2')?.focus({ preventScroll: true });
    appointment.querySelector('mr-appointment-slider')?.layout();
    animatePanel(panel, previousHeight);
    return true;
  };
  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('mr-appointment-slider');
    const navigation = slider?.closest('[data-mr-navigation]');
    if (!navigation || !openAppointment(navigation)) return;
    requestAnimationFrame(() => slider.selectBlock?.(event.detail.blockId));
  });
  let footerFrame;
  const updateFooterOffset = () => {
    footerFrame = undefined;
    const footer = document.querySelector('[data-mr-footer]');
    const bounds = footer?.getBoundingClientRect();
    const visibleHeight = bounds ? Math.max(0, Math.min(window.innerHeight, bounds.bottom) - Math.max(0, bounds.top)) : 0;
    document.documentElement.style.setProperty('--mr-footer-visible-height', `${Math.ceil(visibleHeight)}px`);
    const navigation = document.querySelector('[data-mr-navigation]');
    const rowHeight = navigation?.querySelector('nav')?.getBoundingClientRect().height || 40;
    const menuBottom = navigation ? parseFloat(getComputedStyle(navigation.querySelector('.shop-nav')).bottom) || 0 : 25;
    document.documentElement.style.setProperty('--mr-appointment-panel-height', `${Math.max(100, window.innerHeight - menuBottom - rowHeight - 12)}px`);
  };
  const scheduleFooterOffset = () => {
    if (footerFrame === undefined) footerFrame = requestAnimationFrame(updateFooterOffset);
  };
  window.addEventListener('scroll', scheduleFooterOffset, { passive: true });
  window.addEventListener('resize', scheduleFooterOffset);
  window.visualViewport?.addEventListener('resize', scheduleFooterOffset);
  document.addEventListener('shopify:section:load', scheduleFooterOffset);
  const footerResizeObserver = new ResizeObserver(scheduleFooterOffset);
  ['[data-mr-footer]', '#MainContent'].forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) footerResizeObserver.observe(element);
  });
  scheduleFooterOffset();
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const cookieLink = event.target.closest('[data-mr-cookie-preferences]');
    if (cookieLink && typeof window.privacyBanner?.showPreferences === 'function') {
      event.preventDefault();
      const navigation = cookieLink.closest('[data-mr-navigation]');
      if (navigation) closePanels(navigation);
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => window.location.assign(cookieLink.href));
      return;
    }
    const appointmentLink = event.target.closest('[data-mr-appointment-trigger]');
    const appointmentNavigation = appointmentLink?.closest('[data-mr-navigation]');
    if (appointmentNavigation && appointmentNavigation.querySelector('[data-mr-appointment-panel]')) {
      event.preventDefault();
      openAppointment(appointmentNavigation);
      return;
    }
    const button = event.target.closest('[data-mr-panel]');
    if (button) {
      const navigation = button.closest('[data-mr-navigation]');
      const panel = document.getElementById(button.dataset.mrPanel);
      if (!navigation || !panel) return;
      if (panel.hasAttribute('data-mr-appointment-open')) {
        const previousHeight = panel.getBoundingClientRect().height;
        showShopMenu(navigation);
        animatePanel(panel, previousHeight);
        return;
      }
      const opening = button.getAttribute('aria-expanded') !== 'true';
      closePanels(navigation);
      button.setAttribute('aria-expanded', String(opening));
      panel.hidden = !opening;
      return;
    }
    document.querySelectorAll('[data-mr-navigation]').forEach((navigation) => {
      if (!navigation.contains(event.target)) closePanels(navigation);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mr-navigation]').forEach((navigation) => {
      const panel = navigation.querySelector('[data-mr-shop-panel]');
      if (panel?.hasAttribute('data-mr-appointment-open')) {
        const previousHeight = panel.getBoundingClientRect().height;
        showShopMenu(navigation, true);
        animatePanel(panel, previousHeight);
      } else closePanels(navigation, true);
    });
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event.cartData;
      if (cart && typeof cart.item_count === 'number') {
        document.querySelectorAll('[data-mr-cart-count]').forEach((count) => { count.textContent = `[${cart.item_count}]`; });
      } else {
        fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json()).then((data) => {
          document.querySelectorAll('[data-mr-cart-count]').forEach((count) => { count.textContent = `[${data.item_count}]`; });
        }).catch(() => {});
      }
    });
  }
})();

